import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'
import { ServerMarkdown } from '../ServerMarkdown'

const DynamicClientMdRender = dynamic(() => import('../ClientMarkdown'), {
  ssr: false,
})

type Props = {
  content: string
  classes?: string
}

export const MarkdownSwitcher = ({ content, classes }: Props): JSX.Element => {
  const [isBrowser, setIsBrowser] = useState(false)

  useEffect(() => {
    setIsBrowser(true)
  }, [])

  return isBrowser ? (
    <DynamicClientMdRender {...{ content, classes }} />
  ) : (
    <ServerMarkdown {...{ content }} />
  )
}
